
import handleError from '@/scripts/handleError.js'
import link from "@/scripts/host.js";
import axios from 'axios'
import store from '../store/index.js';


export default function loggedIn() {
    let actualTime = new Date();
    let tokenExpiration;
    let token;
    let refreshToken;
  
    if (localStorage.getItem("user")) {
      tokenExpiration = new Date(
        JSON.parse(localStorage.getItem("user")).tokenExpiration
      );
      token = JSON.parse(localStorage.getItem("user")).token;
      refreshToken = JSON.parse(localStorage.getItem("user")).refreshToken;
    } else if (sessionStorage.getItem("user")) {
      tokenExpiration = new Date(
        JSON.parse(sessionStorage.getItem("user")).tokenExpiration
      );
      token = JSON.parse(sessionStorage.getItem("user")).token;
      refreshToken = JSON.parse(sessionStorage.getItem("user")).refreshToken;
    }
    if (actualTime < tokenExpiration) {
      if (
        localStorage.getItem("user") &&
        JSON.parse(localStorage.getItem("user")).token
      ) {
        return JSON.parse(localStorage.getItem("user")).token;
      } else if (
        sessionStorage.getItem("user") &&
        JSON.parse(sessionStorage.getItem("user")).token
      ) {
        return JSON.parse(sessionStorage.getItem("user")).token;
      }
    } else {
      return axios({
        url: `${link.hostLink}Account/Refresh`,
        method: "post",
        data: { Token: token, RefreshToken: refreshToken },
      })
        .then((res) => {
          if (localStorage.getItem("user")) {
            let user = JSON.parse(localStorage.getItem("user"));
            user.token = res.data.data.token;
            user.refreshToken = res.data.data.refreshToken;
            user.tokenExpiration = res.data.data.tokenExpiration;
            localStorage.setItem("user", JSON.stringify(user));
          }
          if (sessionStorage.getItem("user")) {
            let user = JSON.parse(sessionStorage.getItem("user"));
            user.token = res.data.data.token;
            user.refreshToken = res.data.data.refreshToken;
            user.tokenExpiration = res.data.data.tokenExpiration;
            sessionStorage.setItem("user", JSON.stringify(user));
          }
          return res.data.data.token;
        })
        .catch(() => {
          clearStorage();
          handleError("Sesja wygasła. Zaloguj się ponownie.");
        });
    }
    
  }
  
  function clearStorage() {
      localStorage.removeItem('user');
      sessionStorage.removeItem('user');
      store.dispatch("toggleLoginModal");    
      store.dispatch('setLogInFlag', false);
    }